import { useState, useCallback } from 'react';

const useDeletionConfirm = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [pendingDeletion, setPendingDeletion] = useState(null);
    const [loading, setLoading] = useState(false);

    const confirmDeletion = useCallback(({
        onDelete,
        title,
        message,
        itemName,
        requireReason = true,
        additionalData = null
    }) => {
        setPendingDeletion({
            onDelete,
            title,
            message,
            itemName,
            requireReason,
            additionalData
        });
        setIsModalOpen(true);
    }, []);

    const handleConfirm = useCallback(async (reason) => {
        if (!pendingDeletion) return;

        try {
            setLoading(true);

            // Call the deletion function with reason and any additional data
            await pendingDeletion.onDelete(reason, pendingDeletion.additionalData);

            // Close modal and reset state
            setIsModalOpen(false);
            setPendingDeletion(null);
        } catch (error) {
            // Error should be handled by the calling component
            console.error('Deletion failed:', error);
            throw error; // Re-throw so calling component can handle
        } finally {
            setLoading(false);
        }
    }, [pendingDeletion]);

    const handleCancel = useCallback(() => {
        setIsModalOpen(false);
        setPendingDeletion(null);
        setLoading(false);
    }, []);

    return {
        // Modal state
        isModalOpen,
        loading,

        // Modal props
        modalProps: pendingDeletion ? {
            title: pendingDeletion.title,
            message: pendingDeletion.message,
            itemName: pendingDeletion.itemName,
            requireReason: pendingDeletion.requireReason
        } : {},

        // Functions
        confirmDeletion,
        handleConfirm,
        handleCancel
    };
};

export default useDeletionConfirm;